export const ROLE_NAMES = {
  0: '超级管理员',
  1: '系统管理员',
  2: '渠道管理员',
  3: '维护人员',
  4: '财务人员'
}

export const PHOTO_TYPES = [
  { id: 1, name: '健康证', fee: 2000 },
  { id: 2, name: '身份证', fee: 2000 },
  { id: 3, name: '社保卡', fee: 2000 },
  { id: 4, name: '驾驶证', fee: 2500 },
  { id: 5, name: '护照', fee: 3000 },
  { id: 6, name: '港澳通行证', fee: 3000 },
  { id: 7, name: '居住证', fee: 2000 },
  { id: 8, name: '职业资格证', fee: 2500 },
  { id: 9, name: '船员证', fee: 3000 },
  { id: 10, name: '退役军人证', fee: 2000 }
]

export const channels = [
  { id: 1, channelName: '深圳南山渠道', opratorAccount: 'admin', createTime: '2026-01-12 10:00:00', updateTime: '2026-08-01 09:20:00' },
  { id: 2, channelName: '广州天河渠道', opratorAccount: 'admin', createTime: '2026-02-08 11:30:00', updateTime: '2026-07-18 16:40:00' },
  { id: 3, channelName: '东莞松山湖渠道', opratorAccount: 'channel01', createTime: '2026-03-21 14:12:00', updateTime: '2026-08-20 08:11:00' }
]

export const devices = [
  { id: 1, deviceCode: 'PE-NS-0001', channelId: 1, channelName: '深圳南山渠道', address: '南山政务服务中心', status: 1, paperCount: 186, softVersion: '1.0.3', payConfigName: '收钱吧-南山', opratorAccount: 'admin', createTime: '2026-04-01 09:00:00', updateTime: '2026-08-25 18:00:00' },
  { id: 2, deviceCode: 'PE-TH-0008', channelId: 2, channelName: '广州天河渠道', address: '天河市民中心', status: 1, paperCount: 42, softVersion: '1.0.3', payConfigName: '收钱吧-天河', opratorAccount: 'admin', createTime: '2026-04-15 09:00:00', updateTime: '2026-08-24 12:10:00' },
  { id: 3, deviceCode: 'PE-DG-0012', channelId: 3, channelName: '东莞松山湖渠道', address: '松山湖人才大厦', status: 0, paperCount: 0, softVersion: '1.0.2', payConfigName: '收钱吧-东莞', opratorAccount: 'channel01', createTime: '2026-06-02 09:00:00', updateTime: '2026-08-10 10:00:00' }
]

export const payConfigs = [
  { id: 1, payConfigName: '收钱吧-南山', activeCode: 'AC-NS-8821', notes: '南山渠道默认支付', opratorAccount: 'admin', createTime: '2026-03-01 10:00:00', updateTime: '2026-07-01 10:00:00' },
  { id: 2, payConfigName: '收钱吧-天河', activeCode: 'AC-TH-3390', notes: '天河渠道默认支付', opratorAccount: 'admin', createTime: '2026-03-08 10:00:00', updateTime: '2026-07-12 10:00:00' },
  { id: 3, payConfigName: '收钱吧-东莞', activeCode: 'AC-DG-1102', notes: '', opratorAccount: 'channel01', createTime: '2026-05-20 10:00:00', updateTime: '2026-06-01 10:00:00' }
]

export const users = [
  { id: 1, account: 'admin', name: '系统管理员', role: 1, channelId: 1, channelName: '深圳南山渠道', status: 1, expireDate: '2026-12-31 23:59:59', loginTime: '2026-08-26 08:10:00', loginIp: '10.0.1.21', opratorAccount: 'super' },
  { id: 2, account: 'channel01', name: '渠道运维', role: 2, channelId: 3, channelName: '东莞松山湖渠道', status: 1, expireDate: '2026-11-30 23:59:59', loginTime: '2026-08-25 17:22:00', loginIp: '10.0.3.18', opratorAccount: 'admin' },
  { id: 3, account: 'finance01', name: '财务经办', role: 4, channelId: 1, channelName: '深圳南山渠道', status: 0, expireDate: '2026-10-01 23:59:59', loginTime: '2026-08-20 09:00:00', loginIp: '10.0.1.88', opratorAccount: 'admin' }
]

export const photos = [
  { id: 101, deviceCode: 'PE-NS-0001', channelName: '深圳南山渠道', idName: '张伟', idNumber: '440300199001011234', sex: '男', photoTypeName: '身份证', createTime: '2026-08-26 09:12:33', payStatus: 1, orderId: 9001, status: 1 },
  { id: 102, deviceCode: 'PE-TH-0008', channelName: '广州天河渠道', idName: '李娜', idNumber: '440106199205052345', sex: '女', photoTypeName: '护照', createTime: '2026-08-26 10:05:11', payStatus: 1, orderId: 9002, status: 1 },
  { id: 103, deviceCode: 'PE-NS-0001', channelName: '深圳南山渠道', idName: '王强', idNumber: '440304198812123456', sex: '男', photoTypeName: '驾驶证', createTime: '2026-08-25 16:40:08', payStatus: 0, orderId: 0, status: 1 },
  { id: 104, deviceCode: 'PE-DG-0012', channelName: '东莞松山湖渠道', idName: '陈静', idNumber: '441900199311214567', sex: '女', photoTypeName: '健康证', createTime: '2026-08-24 11:28:50', payStatus: 2, orderId: 0, status: 1 }
]

export const payOrders = [
  { id: 9001, orderNumber: '202608260001', fee: 2000, deviceCode: 'PE-NS-0001', channelName: '深圳南山渠道', payMethod: 1, idName: '张伟', idNumber: '440300199001011234', photoTypeName: '身份证', createTime: '2026-08-26 09:10:00', payTime: '2026-08-26 09:11:20', payStatus: true, tradeNumber: 'WX202608260011', refund: 0 },
  { id: 9002, orderNumber: '202608260002', fee: 3000, deviceCode: 'PE-TH-0008', channelName: '广州天河渠道', payMethod: 2, idName: '李娜', idNumber: '440106199205052345', photoTypeName: '护照', createTime: '2026-08-26 10:03:00', payTime: '2026-08-26 10:04:18', payStatus: true, tradeNumber: 'ALI202608260022', refund: 0 },
  { id: 9003, orderNumber: '202608250018', fee: 2500, deviceCode: 'PE-NS-0001', channelName: '深圳南山渠道', payMethod: 1, idName: '赵磊', idNumber: '440305198707076789', photoTypeName: '驾驶证', createTime: '2026-08-25 14:20:00', payTime: '2026-08-25 14:21:02', payStatus: true, tradeNumber: 'WX202608250188', refund: 1 }
]

export const refunds = [
  { orderId: 9003, orderNumber: '202608250018', idName: '赵磊', refundAmount: 2500, reason: '拍照失败申请退款', operaterName: 'finance01', refundTime: '2026-08-25 15:08:00' }
]

export const dayStats = [
  { date: '2026-08-20', photoCount: 36, payCount: 32, amountTotal: 72000, refundCount: 1, refundAmount: 2000 },
  { date: '2026-08-21', photoCount: 41, payCount: 38, amountTotal: 86000, refundCount: 0, refundAmount: 0 },
  { date: '2026-08-22', photoCount: 28, payCount: 25, amountTotal: 55000, refundCount: 0, refundAmount: 0 },
  { date: '2026-08-23', photoCount: 52, payCount: 49, amountTotal: 110000, refundCount: 2, refundAmount: 4500 },
  { date: '2026-08-24', photoCount: 33, payCount: 30, amountTotal: 68000, refundCount: 0, refundAmount: 0 },
  { date: '2026-08-25', photoCount: 47, payCount: 44, amountTotal: 98000, refundCount: 1, refundAmount: 2500 },
  { date: '2026-08-26', photoCount: 19, payCount: 16, amountTotal: 36000, refundCount: 0, refundAmount: 0 }
]

export const monthStats = [
  { month: '2026-03', photoCount: 620, payCount: 580, amountTotal: 1280000, refundCount: 8, refundAmount: 18000 },
  { month: '2026-04', photoCount: 710, payCount: 668, amountTotal: 1460000, refundCount: 6, refundAmount: 14000 },
  { month: '2026-05', photoCount: 803, payCount: 760, amountTotal: 1680000, refundCount: 11, refundAmount: 26000 },
  { month: '2026-06', photoCount: 756, payCount: 710, amountTotal: 1550000, refundCount: 5, refundAmount: 12000 },
  { month: '2026-07', photoCount: 890, payCount: 842, amountTotal: 1860000, refundCount: 9, refundAmount: 21000 },
  { month: '2026-08', photoCount: 540, payCount: 508, amountTotal: 1120000, refundCount: 4, refundAmount: 9000 }
]

export const deviceStats = [
  { deviceCode: 'PE-NS-0001', channelName: '深圳南山渠道', address: '南山政务服务中心', photoCount: 286, payCount: 270, amountTotal: 598000, paperCount: 186 },
  { deviceCode: 'PE-TH-0008', channelName: '广州天河渠道', address: '天河市民中心', photoCount: 194, payCount: 180, amountTotal: 412000, paperCount: 42 },
  { deviceCode: 'PE-DG-0012', channelName: '东莞松山湖渠道', address: '松山湖人才大厦', photoCount: 60, payCount: 58, amountTotal: 110000, paperCount: 0 }
]

export const operationLogs = [
  { id: 1, account: 'admin', modelName: '设备管理', opratorType: '修改', result: '更新设备 PE-NS-0001 相纸数量', ip: '10.0.1.21', createTime: '2026-08-26 11:20:00' },
  { id: 2, account: 'finance01', modelName: '退款记录', opratorType: '退款', result: '订单 202608250018 退款 25.00 元', ip: '10.0.1.88', createTime: '2026-08-25 15:08:00' },
  { id: 3, account: 'channel01', modelName: '渠道管理', opratorType: '查询', result: '查看渠道列表', ip: '10.0.3.18', createTime: '2026-08-25 09:40:00' }
]

export const loginLogs = [
  { id: 1, account: 'admin', opratorType: '登录成功', result: '帐号[admin]登录成功！', ip: '10.0.1.21', createTime: '2026-08-26 08:10:00' },
  { id: 2, account: 'admin', opratorType: '登录成功', result: '检测到帐号在其他设备登录,被强制下线', ip: '10.0.1.30', createTime: '2026-08-25 18:02:00' },
  { id: 3, account: 'unknown', opratorType: '登录失败', result: '密码错误', ip: '203.0.113.18', createTime: '2026-08-25 03:12:00' }
]

export const securityLogs = [
  { id: 1, account: 'unknown', modelName: '登录', opratorType: '暴力尝试', result: '连续失败 6 次，IP 已锁定', ip: '203.0.113.18', createTime: '2026-08-25 03:18:00' },
  { id: 2, account: 'admin', modelName: '会话', opratorType: '踢下线', result: '账号在其他设备登录', ip: '10.0.1.30', createTime: '2026-08-25 18:02:00' }
]

export const lockedIps = [
  { account: 'unknown', ipAddress: '203.0.113.18', lockTime: '2026-08-25 03:18:00' },
  { account: 'guest', ipAddress: '198.51.100.44', lockTime: '2026-08-22 21:05:00' }
]

export const defaultMenus = [
  {
    name: '业务办理', tag: 'A1', visible: true,
    list: [
      { name: '拍照信息管理', tag: 'A101', visible: true, list: [{ name: '查询', tag: 'A10101', visible: true }] },
      { name: '缴费信息管理', tag: 'A102', visible: true, list: [{ name: '查询', tag: 'A10201', visible: true }] },
      { name: '退款记录', tag: 'A103', visible: true, list: [{ name: '查询', tag: 'A10301', visible: true }, { name: '退款', tag: 'A10302', visible: true }] }
    ]
  },
  {
    name: '统计报表', tag: 'A2', visible: true,
    list: [
      { name: '每日统计', tag: 'A201', visible: true, list: [{ name: '查询', tag: 'A20101', visible: true }] },
      { name: '每月统计', tag: 'A202', visible: true, list: [{ name: '查询', tag: 'A20201', visible: true }] },
      { name: '设备统计', tag: 'A203', visible: true, list: [{ name: '查询', tag: 'A20301', visible: true }] }
    ]
  },
  {
    name: '系统管理', tag: 'A3', visible: true,
    list: [
      { name: '渠道管理', tag: 'A301', visible: true, list: [{ name: '查询', tag: 'A30101', visible: true }, { name: '编辑', tag: 'A30102', visible: true }] },
      { name: '设备管理', tag: 'A302', visible: true, list: [
        { name: '渠道', tag: 'A30201', visible: true },
        { name: '新增设备', tag: 'A30202', visible: true },
        { name: '编辑', tag: 'A30203', visible: true },
        { name: '删除', tag: 'A30204', visible: true },
        { name: '查询', tag: 'A30205', visible: true },
        { name: '启用', tag: 'A30206', visible: true },
        { name: '禁用', tag: 'A30207', visible: true },
        { name: '配置信息', tag: 'A30208', visible: true },
        { name: '激活支付', tag: 'A30210', visible: true },
        { name: '相片设置', tag: 'A30211', visible: true }
      ] },
      { name: '支付配置', tag: 'A303', visible: true, list: [{ name: '查询', tag: 'A30301', visible: true }, { name: '编辑', tag: 'A30302', visible: true }] },
      { name: '帐户管理', tag: 'A304', visible: true, list: [{ name: '查询', tag: 'A30401', visible: true }, { name: '编辑', tag: 'A30402', visible: true }] },
      { name: '权限管理', tag: 'A305', visible: true, list: [{ name: '查询', tag: 'A30501', visible: true }, { name: '授权', tag: 'A30502', visible: true }] },
      { name: '相片规格', tag: 'A306', visible: true, list: [{ name: '新增', tag: 'A30601', visible: true }, { name: '编辑', tag: 'A30602', visible: true }, { name: '删除', tag: 'A30603', visible: true }] }
    ]
  },
  {
    name: '安全审计', tag: 'A4', visible: true,
    list: [
      { name: '操作日志', tag: 'A401', visible: true, list: [{ name: '查询', tag: 'A40101', visible: true }] },
      { name: '安全日志', tag: 'A402', visible: true, list: [{ name: '查询', tag: 'A40201', visible: true }] },
      { name: '登录日志', tag: 'A403', visible: true, list: [{ name: '查询', tag: 'A40301', visible: true }] },
      { name: '锁定IP', tag: 'A404', visible: true, list: [{ name: '查询', tag: 'A40401', visible: true }, { name: '删除', tag: 'A40402', visible: true }] }
    ]
  }
]

export const roles = [
  { roleId: 1, roleName: '系统管理员', menuAccess: JSON.parse(JSON.stringify(defaultMenus)) },
  { roleId: 2, roleName: '渠道管理员', menuAccess: JSON.parse(JSON.stringify(defaultMenus)) },
  { roleId: 3, roleName: '维护人员', menuAccess: JSON.parse(JSON.stringify(defaultMenus)) },
  { roleId: 4, roleName: '财务人员', menuAccess: JSON.parse(JSON.stringify(defaultMenus)) }
]
